import React from "react";
import { MapContainer, Polyline, TileLayer, useMap } from "react-leaflet";
import { makeStyles } from "@mui/styles";
import { FormControl, FormLabel, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import "leaflet/dist/leaflet.css";

const ROUTES = [
    {
        name: "Lake Short",
        value: "polyline_lake_short",
        center: [45.444880, -80.044429],
        zoom: 14,
        color: "#ff6f00",
    },
    {
        name: "Lake Long",
        value: "polyline_lake_long",
        center: [45.470088, -80.053576],
        zoom: 12,
        color: "#ff6f00",
    },
    {
        name: "Reservoir",
        value: "polyline_reservoir",
        center: [43.772492, -79.463827],
        zoom: 16,
        color: "#ff6f00",
    },
];

const polylineOptions = {
    bubblingMouseEvents: true,
    dashArray: null,
    dashOffset: null,
    lineCap: "round",
    lineJoin: "round",
    noClip: true,
    opacity: 1,
    smoothFactor: 1.0,
    stroke: true,
};

const useStyles = makeStyles(() => ({
    radio: {
        color: '#9CA9B3',
        '&$checked': { color: '#93cdff' },
    },
    checked: {},
}));

function ChangeView({ activeRoute, setActiveRoute }) {
    const map = useMap();
    const classes = useStyles();

    const handleChange = (e) => {
        const selected = ROUTES.find(r => r.value === e.target.value);
        if (selected) {
            setActiveRoute(selected.value);
            map.flyTo(selected.center, selected.zoom);
        }
    };

    return (
        <div className="leaflet-bottom leaflet-right">
            <div className="leaflet-control leaflet-bar"
                 style={{border: 'none', color: 'white', backgroundColor: '#151719', padding: '4px 6px'}}>
                <FormControl component="fieldset">
                    <FormLabel component="legend" style={{color: '#9CA9B3', fontSize: '0.7rem'}}>Route</FormLabel>
                    <RadioGroup aria-label="Route" value={activeRoute} onChange={handleChange}>
                        {ROUTES.map(r => (
                            <FormControlLabel
                                key={r.value}
                                value={r.value}
                                style={{color: '#9CA9B3', fontSize: '0.7rem', marginBottom: '-6px'}}
                                control={<Radio size="small" classes={{root: classes.radio, checked: classes.checked}}/>}
                                label={<span style={{fontSize: '0.7rem'}}>{r.name}</span>}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </div>
        </div>
    );
}

function Map() {
    const [activeRoute, setActiveRoute] = React.useState("polyline_lake_long");
    const [polylineData, setPolylineData] = React.useState(null);

    React.useEffect(() => {
        let cancelled = false;
        fetch(process.env.PUBLIC_URL + "/data/routes.json")
            .then(r => r.json())
            .then(data => { if (!cancelled) setPolylineData(data); })
            .catch(err => console.error("Failed to load route polylines", err));
        return () => { cancelled = true; };
    }, []);

    return (
        <MapContainer
            id="map_5bea2c8b8d3f4b61846d977addff3e1f"
            center={[45.470088, -80.053576]}
            zoom={12}
            scrollWheelZoom={false}
            style={{ height: 400, width: "100%" }}
        >
            <ChangeView activeRoute={activeRoute} setActiveRoute={setActiveRoute} />
            <TileLayer
                attribution='Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community'
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
            />
            {polylineData && ROUTES.map(r => {
                const positions = polylineData[r.value];
                if (!positions || positions.length === 0) return null;
                return (
                    <Polyline
                        key={r.value}
                        positions={positions}
                        pathOptions={{
                            ...polylineOptions,
                            color: r.color,
                            opacity: activeRoute === r.value ? 1 : 0.45,
                        }}
                    />
                );
            })}
        </MapContainer>
    );
}

export default Map;
